import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import { connect } from 'react-redux';

import Button from '@material-ui/core/Button';

import EsmsCard from '../../components/EsmsCard';

import { isAllowed } from '../../helpers/auth';
import { Permissions } from '../../helpers/permissions';

import classes from './UsersCard.module.css';

class UsersCard extends Component {
    handlePageRoute = () => {
        const { history } = this.props;

        history.push('/admin/users' + history.location.search);
    }

    render() {
        const { users, currentScopes } = this.props;
        if (!users) {
            return null;
        }
        return (
            <EsmsCard
                title="Users"
                imagePath="/assets/images/usersFlat.svg"
            >
                <div className={classes.innerContainer}>
                    <div className={classes.usersInfo}>
                        <p>
                            <span className={classes.label}>Company Users</span>
                            <span className={classes.values}>
                                {users.filter(user => user.status === 'confirmed').length}
                            </span>
                        </p>
                        <p>
                            <span className={classes.label}>Invited Users</span>
                            <span className={classes.values}>
                                {users.filter(user => user.status === 'invited').length}
                            </span>
                        </p>
                    </div>
                    {
                        isAllowed(currentScopes, Permissions('adminFull')) && (
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={this.handlePageRoute}
                            >
                                Manage Users
                            </Button>
                        )
                    }
                </div>
            </EsmsCard>
        );
    }
}

const mapStateToProps = state => {
    return {
        companyInfo:   state.companyInfo,
        currentScopes: state.core.currentScopes
    };
};

export default withRouter(connect(mapStateToProps)(UsersCard));
